import React from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import LoadingOverlay from 'react-loading-overlay';

const FullPageSpinner = (props) => {
    const spinnerSelector = useSelector(state => state.spinner);
    //const isActive = true;
    return (
        <LoadingOverlay
            active={spinnerSelector.visible}
            spinner
            text='Loading...'>
            {props.children}
        </LoadingOverlay>
    )
}

export const WorksheetSpinner = (props) => {
    
    const spinnerSelector = useSelector(state => state.spinner);
    //const isActive = true;
    return (
        <LoadingOverlay
            active={spinnerSelector.visible}
            spinner
            classNamePrefix="_worksheet_overlay_"
            text='Loading...'>
            {props.children}
        </LoadingOverlay>
    )
}

export default FullPageSpinner;